import React, { useContext, useMemo } from 'react'
import { CardMeta, CardTitle, Container, ImgCover, ItemType, ListContainer, ListWrapper, ShareContainer, Thumbnail } from './styled'
import Button from 'components/Form/Button';
import { Icon } from 'ui/styled';
import { isModularContentType, parseStrapiImage } from 'utils';

import Toggle from 'components/Form/Toggle';
import LockedContentOverlay from 'components/LockedContentOverlay';
import { CoreContext } from 'context/CoreContext';
import { openLockedContentModal } from 'utils/lockedContent';
import AudienceAccessIndicators from 'components/AudienceAccessIndicators';
import { getContentAudiences } from 'utils/audienceAccess';

export default function ItemsList({ item, handleDownload, shareLink,
  selected,
  onToggleSelect,
  onToggleFavorite,
  favoriteLoading,
  noShare, }) {
  const { setModal } = useContext(CoreContext)
  const locked = item?.accessState === 'locked'
  const currentFile = useMemo(() => {
    const fileUrl = item?.file?.url ? parseStrapiImage(item?.file?.url) : item?.document;
    const slices = fileUrl?.split(".");
    const extension = slices?.[slices?.length - 1];

    return {
      url: fileUrl,
      extension,
    };
  }, [item]);

  const handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (typeof onToggleSelect === 'function') {
      onToggleSelect({
        targetUid: item?.uid,
        targetDocumentId: item?.documentId,
      })
    }
  }

  const handleFavorite = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (typeof onToggleFavorite === 'function') {
      onToggleFavorite(item)
    }
  }
  return (
    <ListContainer
      role="button"
      tabIndex={0}
      aria-disabled={locked}
      aria-label={locked ? `${item?.title || 'Content'}. Exclusive content` : `Open ${item?.title || 'content'}`}
      onClick={() => locked ? openLockedContentModal(setModal, item) : handleDownload(item, currentFile)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          locked ? openLockedContentModal(setModal, item) : handleDownload(item, currentFile)
        }
      }}
    >
      <ListWrapper >
        <Thumbnail>
          <ImgCover
            src={(/\.(png|jpe?g|gif|webp)$/i).test(item?.image?.url || '') ? item?.image?.url : item?.cover}
            alt={item?.title}
            draggable={false}
          />
        </Thumbnail>
        <Container column>
          <CardTitle>{item?.title}</CardTitle>
          {item?.document_type ? (
            <CardMeta>
              <ItemType>{item.document_type}</ItemType>
            </CardMeta>
          ) : null}
        </Container>
      </ListWrapper>

      <Container>
        {!locked && typeof onToggleFavorite === 'function' ? (
          <Button onClick={handleFavorite} nospace small width={'fit-content'} link color='primary' outline><Icon icon={item?.isFavorite ? 'heart-active' : 'heart'} pointer /></Button>

        ) : null}

        {item?.type === 'courses' ? null : (
          <AudienceAccessIndicators audiences={getContentAudiences(item)} inline />
        )}

        {locked || !shareLink || noShare ? null : (
          <ShareContainer onClick={handleToggle}>
            <Toggle label={'Add item'} checked={!!selected} />
          </ShareContainer>
        )}
        {locked || isModularContentType(item?.type) ? null :
          <Button small width={'fit-content'} nospace link color='primary' outline><Icon icon='download' /></Button>
        }
      </Container>
      {locked ? <LockedContentOverlay /> : null}

    </ListContainer>
  )
}
